import type { ReactNode } from 'react';
import { Text } from '@radix-ui/themes';

export function ErrorText({ children }: { children: ReactNode }) {
  return (
    <Text as="p" size="2" color="red">
      {children}
    </Text>
  );
}
